import React, { useEffect, useRef, useState } from 'react';
import styles from './Steps.module.css';
import StartMyJourney from './StartMyJourney';
import stepsImg from "../../assets/3-easy-steps.webp";
import stepsImgSS from "../../assets/3-easy-steps-ss.webp";

function Steps({ switchAndSaveSource }) {
    const [isVisible, setIsVisible] = useState(false);
    const elementRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            {
                threshold: 0.25,
            }
        );

        let currentElement = elementRef.current;
        if (currentElement) {
            observer.observe(currentElement);
        }
        return () => {
            if (currentElement) {
                observer.unobserve(currentElement);
            }
        };
    }, []);

    return (
        <div className={styles.stepsSection}>
            
            <div className={styles.imageContainer}>
                <img className={styles.stepsImage} src={switchAndSaveSource ? stepsImgSS : stepsImg} alt='Three easy steps' />
            </div>

            <div className={styles.sectionRightSide}>

                <div ref={elementRef}  className={styles.easySteps + (isVisible ? ' animate__animated animate__fadeInDown' : '')}>
                    <h2 className={styles.easyStepsHeader}>3 Easy steps</h2>
                </div>

                <div className={styles.stepsContainer}>

                    <div className={styles.step + (isVisible ? ' animate__animated animate__pulse' : '')} ref={elementRef}>
                            <p className={styles.stepNumber}>1</p>
                            <span className={styles.stepText}>Set your goals</span>
                    </div>

                    <div className={styles.step + (isVisible ? ' animate__animated animate__pulse' : '')} ref={elementRef}>
                        <p className={styles.stepNumber}>2</p>
                        <span className={styles.stepText}>Choose your plan</span>
                    </div>

                    <div className={styles.step + (isVisible ? ' animate__animated animate__pulse' : '')} ref={elementRef}>
                        <p className={styles.stepNumber}>3</p>
                        <span className={styles.stepText}>Talk to your clinician</span>
                    </div>

                </div>

                <StartMyJourney />

            </div>
            
        </div>
    );
}

export default Steps;
